import { whiteLabelFeatures } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { SectionLabel } from "./ExecSummary";
import { Layers, Palette, Globe, ToggleLeft, Banknote, Users2 } from "lucide-react";

const ICONS = [Layers, Palette, Globe, ToggleLeft, Banknote, Users2];

export default function WhiteLabel() {
  return (
    <section
      id="whitelabel"
      data-testid={ROADMAP.whiteLabelSection}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="05" label="White-Label Platform" />
        <div className="grid lg:grid-cols-12 gap-6 mt-3 items-end">
          <h2 className="lg:col-span-7 font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold">
            One platform. Infinite brands. Built to be resold.
          </h2>
          <p className="lg:col-span-5 text-[#495057] leading-relaxed">
            Gr8Boost ERP is engineered from day one for multi-tenant white-labelling — perfect for
            implementation partners, regional resellers, and group companies.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border border-[#0A0A0A]">
          {whiteLabelFeatures.map((f, i) => {
            const Icon = ICONS[i % ICONS.length];
            const isLastCol = (i + 1) % 3 === 0;
            const isLastRow = i >= whiteLabelFeatures.length - (whiteLabelFeatures.length % 3 || 3);
            return (
              <div
                key={f.title}
                className={`p-7 lg:p-8 bg-white hover:bg-[#F8F9FA] transition-colors duration-200 ${
                  !isLastCol ? "lg:border-r border-[#0A0A0A]" : ""
                } ${(i + 1) % 2 === 0 ? "md:border-r-0 lg:border-r" : "md:border-r border-[#0A0A0A]"} ${
                  isLastCol ? "lg:border-r-0" : ""
                } ${!isLastRow ? "border-b border-[#0A0A0A]" : ""}`}
                data-testid={`whitelabel-feature-${i}`}
              >
                <div className="w-10 h-10 border border-[#0A0A0A] flex items-center justify-center mb-5">
                  <Icon size={18} />
                </div>
                <h3 className="font-heading text-lg font-semibold tracking-tight mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-[#495057] leading-relaxed">{f.detail}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
